import React, { useState } from 'react';
import { photos, pets, users } from '../mock/albumData';
import AlbumFilters from '../components/AlbumFilters';
import AlbumPhotoCard from '../components/AlbumPhotoCard';
import AlbumUploadModal from '../components/AlbumUploadModal';

const AlbumPage = () => {
  const [filters, setFilters] = useState({});
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [currentUser] = useState(users[0]); // Simula usuario logueado

  const activities = [...new Set(photos.map(p => p.activity))];
  
  const filteredPhotos = photos.filter(photo => {
    if (filters.date && photo.date !== filters.date) return false;
    if (filters.activity && photo.activity !== filters.activity) return false;
    return true;
  });

  const handleAddComment = (photoId, comment) => {
    // En una app real, aquí se haría una petición al backend
    console.log(`Comentario añadido a foto ${photoId}: ${comment}`);
  };

  const handleUploadPhoto = (photoData) => {
    // En una app real, aquí se subiría la foto al backend
    console.log('Foto subida:', photoData);
    setShowUploadModal(false);
  };

  return (
    <>
      <AlbumFilters 
        activities={activities} 
        onFilterChange={setFilters} 
      />
      
      <div className="ml-64 p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-gray-800">Momentos Masco</h2>
          {currentUser.isStaff && (
            <button 
              onClick={() => setShowUploadModal(true)}
              className="bg-cyan-600 text-white px-4 py-2 rounded-lg hover:bg-cyan-700 flex items-center"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
              Subir foto
            </button>
          )}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {filteredPhotos.map(photo => (
            <AlbumPhotoCard
              key={photo.id}
              photo={photo}
              pets={pets}
              currentUser={currentUser}
              onAddComment={handleAddComment}
            />
          ))}
        </div>
      </div>

      {showUploadModal && (
        <AlbumUploadModal
          pets={pets}
          onClose={() => setShowUploadModal(false)}
          onUpload={handleUploadPhoto}
        />
      )}
    </>
  );
};

export default AlbumPage;

// DONE